import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";
import { scrollToId } from "./scroll";
import { trackEvent } from "./track";
import { useI18n } from "../../i18n";

export const Consultant = () => {
  const { t } = useI18n();
  return (
    <section id="consultant" className="py-24 lg:py-36 border-t border-white/10" data-testid="consultant-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="lg:col-span-5 relative"
        >
          <div className="relative overflow-hidden" style={{ aspectRatio: "4/5" }}>
            <img
              src="/vladimir-blain.jpg"
              alt={t("consultant.photoAlt")}
              className="w-full h-full object-cover"
              style={{ objectPosition: "center 12%" }}
            />
            <div className="absolute inset-0 pointer-events-none" style={{ background: "linear-gradient(160deg, rgba(15,32,39,0.28), rgba(15,32,39,0.05) 45%, rgba(232,163,61,0.08))" }} />
            <div className="absolute bottom-0 left-0 right-0 p-8" style={{ background: "linear-gradient(to top, rgba(15,32,39,0.95), transparent)" }}>
              <p className="font-heading font-bold text-2xl">Vladimir Blain</p>
              <p className="text-gold text-sm tracking-[0.18em] uppercase font-heading mt-1">{t("consultant.role")}</p>
            </div>
          </div>
          <div className="absolute -top-4 -left-4 w-24 h-24 border-t border-l border-[#E8A33D]/60 pointer-events-none" />
          <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b border-r border-[#E8A33D]/60 pointer-events-none" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="lg:col-span-7 lg:pl-8"
        >
          <p className="font-heading text-gold text-sm tracking-[0.25em] uppercase mb-6">{t("consultant.kicker")}</p>
          <h2 className="font-heading font-bold tracking-tighter text-3xl sm:text-4xl lg:text-5xl mb-8">
            {t("consultant.heading")}
          </h2>
          <p className="text-[#8A9DB1] leading-relaxed text-base md:text-lg mb-6 max-w-2xl">{t("consultant.p1")}</p>
          <p className="text-[#8A9DB1] leading-relaxed text-base md:text-lg mb-10 max-w-2xl">
            {t("consultant.p2Before")}
            <span className="text-white font-medium">{t("consultant.p2Brand")}</span>
            {t("consultant.p2After")}
          </p>
          <div
            className="flex items-start gap-3 border-l-2 border-[#E8A33D]/50 bg-white/[0.03] px-5 py-4 mb-8 max-w-2xl"
            data-testid="vytali-promo-band"
          >
            <Sparkles size={16} className="text-gold mt-0.5 shrink-0" strokeWidth={1.6} />
            <p className="text-[#8A9DB1] text-sm leading-relaxed">
              {t("consultant.promoBefore")}
              <span className="text-white/90">{t("consultant.promoBrand")}</span>
              {t("consultant.promoAfter")}
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="https://vytalimarketing.com"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm"
              onClick={() => trackEvent("click_decouvrir_vytali", { location: "consultant" })}
              data-testid="consultant-vytali-cta"
            >
              {t("consultant.vytaliCta")} <ArrowUpRight size={16} />
            </a>
            <button
              onClick={() => scrollToId("contact")}
              className="btn-ghost inline-flex items-center justify-center gap-2 px-7 py-3.5 text-sm"
              data-testid="consultant-contact-cta"
            >
              {t("consultant.writeCta")}
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Consultant;
